import { noop } from "./function";
export const noopPromise = () => Promise.resolve();
export const createNewPromise = () => {
  let resolveLocal = noop;
  const promise = new Promise(resolve => {
    resolveLocal = resolve;
  });
  return {
    promise,
    resolve: resolveLocal
  };
};